import { api2  } from './ApiService';

export default class MemberService {
    
    static async get(key){
        let response =  await api2.post(`/api/v1/member`)
        return response.data
    }

    static async search(key,page,perpage){
        let data ={
            searchKey: key,
            page: page,
            perpage:perpage
        }
        let response =  await api2.post(`/api/v1/member/search`,data)
        return response.data
    }

    static async searchCredit(key,page,perpage){
        let data ={
            searchKey: key,
            page: page,
            perpage:perpage
        }
        let response =  await api2.post(`/api/v1/member/credit/search`,data)
        return response.data
    }
 
    static async create(formData){
        let response = await api2.post(`/api/v1/member/create`,formData)
        return response.data
    }
    static async update(formData){
        let response = await api2.post(`/api/v1/member/update`,formData)
        return response.data
    }
    static async updateCredit(id,credit,updated_by){
        let data = {
            member_id: id,
            credit: credit,
            updated_by: updated_by
        }
        let response = await api2.post(`/api/v1/member/update/credit`,data)
        return response.data
    }
    static async updateException(id,exception){
        let data = {
            id: id,
            exception: exception
        }
        let response = await api2.post(`/api/v1/member/update/exception`,data)
        return response.data
    }
    static async delete(data){
        let response = await api2.post(`/api/v1/member/delete`,data)
        return response.data
    }
    
}


// WEBPACK FOOTER //
// ./src/service/MemberService.js